export default __webpack_public_path__ + "static/media/illugraphic.b8bdfc6c.webp";